import React from "react";
import { Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  ScrollableModalBody,
} from "../../../shared/components/TableElements";
import { s3Url } from "../../../shared/constants";
import defaultVehicleIcon from "@/shared/img/defaultVehicleIcon.png";
import { useTranslation } from "react-i18next";
import { colorBlue } from "../../../utils/palette";

const AssetsPopup = ({ showPopup, setShowPopup, vehicles }) => {
  const { t } = useTranslation("common");

  const handleClose = () => setShowPopup(false);

  return (
    <Modal show={showPopup} centered onHide={handleClose} scrollable>
      <Modal.Header>
        <h4>{t("assigned_assets")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={handleClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <ScrollableModalBody $height={`${window.innerHeight - 300}px`}>
        {/* <ScrollableDiv
          $height={`${window.innerHeight - 300}px`}
          //style={{ height: 200, overflow: "auto" }}
        > */}
        {vehicles.map((v) => (
          <div key={v.veh_id} className="d-flex align-items-center gap-2 p-2">
            <div
              style={{
                border: `1px solid ${colorBlue}`,
                borderRadius: "20px",
              }}
            >
              <img
                src={
                  v.veh_img
                    ? `${s3Url}/org_${v.org_id}/vehicle_${v.veh_id}/${v.veh_img}`
                    : defaultVehicleIcon
                }
                alt="vehicle-img"
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
                className="rounded-circle"
              />
            </div>
            <div className="d-flex flex-column" style={{ maxWidth: "15vw" }}>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {v.name}
              </p>
            </div>
          </div>
        ))}
        {/* </ScrollableDiv> */}
      </ScrollableModalBody>
    </Modal>
  );
};

export default AssetsPopup;
